import Vue from 'vue';
import Router from 'vue-router';

// DEV
import Dev from '@/components/pages/Dev';

// FLOW
import Landing from '@/components/pages/flow/Landing';
import Store from '@/components/pages/flow/Store';
import OrganicStore from '@/components/pages/flow/OrganicStore';

// LEGAL
import TermsOfServices from '@/components/pages/legal/TermsOfServices';
import PrivacyPolicy from '@/components/pages/legal/PrivacyPolicy';

// ACCOUNT
import Finalize from '@/components/pages/account/Finalize';
import Verify from '@/components/pages/account/Verify';
import ResetPasswordAsk from '@/components/pages/account/ResetPasswordAsk';
import ResetPasswordDo from '@/components/pages/account/ResetPasswordDo';

Vue.use(Router)

var router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    // DEFAULT
    { path: '*', redirect: '/' },
    { path: '/', redirect: '/organic-store' },

    // DEV
    { path: '/dev', name: 'Dev', component: Dev },

    // FLOW
    { path: '/landing', name: 'Landing', component: Landing },
    { path: '/store', name: 'Store', component: Store },
    { path: '/organic-store', name: 'OrganicStore', component: OrganicStore },

    // LEGAL
    { path: '/tos', name: 'Terms Of Services', component: TermsOfServices },
    { path: '/pp', name: 'Privacy Policy', component: PrivacyPolicy },

    // LEGACY
    { path: '/create-password/:token/:email', name: 'Create Password', component: Finalize },
    { path: '/forgot-password', name: 'Forgot Password', component: ResetPasswordAsk },
    // ACCOUNT
    { path: '/finalize/:token/:email', name: 'Finalize', component: Finalize },
    { path: '/verify/:token/:email', name: 'Verify', component: Verify },
    { path: '/reset-password/:token', name: 'ResetPasswordDo', component: ResetPasswordDo },
    { path: '/reset-password', name: 'ResetPasswordAsk', component: ResetPasswordAsk },
  ],
});

export default router
